module.exports = __webpack_public_path__ + "static/media/heart-icon.b391c7a9.png";